import React from 'react';
import { useCart, PRODUCTS } from '../context/CartContext';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

const StickyATC = () => {
  const { selectedVariant } = useCart();
  const { t } = useLanguage();
  const { isDark } = useTheme();

  const product = PRODUCTS[selectedVariant] || PRODUCTS['set'];

  const scrollToOrderForm = () => {
    const orderForm = document.getElementById('order-form');
    if (orderForm) {
      orderForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div 
      className={`fixed bottom-0 left-0 w-full border-t py-4 px-4 z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.15)] backdrop-blur-xl transition-colors duration-300 ${
        isDark 
          ? 'bg-slate-900/95 border-slate-700' 
          : 'bg-[#fff7fb]/95 border-[#f2bfd4]'
      }`} 
      id="sticky-atc"
      role="complementary"
      aria-label="Quick add to cart"
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center gap-4">
        {/* Product Info */}
        <div className="flex items-center gap-3">
          <div className={`w-12 h-12 rounded-xl flex items-center justify-center border ${
            isDark 
              ? 'bg-primary/20 border-primary/30' 
              : 'bg-primary/10 border-primary/20'
          }`}>
            <img src="/LorenAura.png" alt="Loren Aura" className="h-8 w-8" width="32" height="32" decoding="async" />
          </div>
          <div>
            <p className={`font-bold text-base ${isDark ? 'text-white' : 'text-[#2d1c2b]'}`}>
              Loren Aura
            </p>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-primary font-bold">৳{product.price}</span>
              <span className={`text-sm ${isDark ? 'text-slate-400' : 'text-[#7b5a6a]'}`}>
                ({product.size})
              </span>
              {product.freeDelivery && (
                <span className="text-xs bg-green-500/20 text-green-600 dark:text-green-400 px-2 py-0.5 rounded-full font-medium">
                  {t.hero.freeDelivery}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* CTA Button - 48px min height for touch target */}
        <button 
          onClick={scrollToOrderForm}
          className="px-6 min-h-[48px] h-12 rounded-full border-2 border-[#f2a1c4] bg-[#E24C8B] text-white font-bold text-sm shadow-[0_10px_20px_-14px_rgba(226,76,139,0.7)] transition-all duration-200 whitespace-nowrap flex items-center justify-center gap-2 hover:bg-[#C83E78] hover:shadow-[0_16px_24px_-18px_rgba(226,76,139,0.85)] hover:scale-[1.02]"
          aria-label={`${t.stickyAtc.addToCart} - ৳${product.price}`}
        >
          <svg 
            className="w-5 h-5" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" 
            />
          </svg>
          <span className="hidden sm:inline">{t.stickyAtc.addToCart}</span>
          <span className="sm:hidden">Order</span>
        </button>
      </div>
    </div>
  );
};

export default StickyATC;
